export {
  dashboardPermissions,
  getDashboardPermissions,
} from "./dashboardPermissions";
export { assistantPermissions } from "./assistantPermissions";
export { budgetPermissions } from "./budgetPermissions";
export {
  administrationPermissions,
  administrationClientPermissions,
} from "./administrationPermissions";
export {
  medicalPermissions,
  medicalMutationPermissions,
  centerMutationPermissions,
  getMedicalPermissions,
} from "./medicalPermissions";
export { imsPermissions, getImsPermissions } from "./imsPermissions";
export {
  warehousePermissions,
  warehouseItemPermissions,
} from "./warehousePermissions";
export {
  requestsPermissions,
  getRequestsPermissions,
} from "./requestsPermissions";
export {
  summariesPermissions,
  summaryItemPermissions,
  summaryServicesPermissions,
  getSummariesPermissions,
  getSummaryItemPermissions,
  getSummaryServicesPermissions,
} from "./summariesPermissions";
export { eventsPermissions, getEventsPermissions } from "./eventsPermissions";
export { getArticoliEventoViewPermissions } from "./articoliEventoPermissions";
export {
  getSalesPermissions,
  salesItemPermissions,
  getSalesItemPermissions,
  getSalesClientPermissions,
  salesSummaryPermissions,
  getSalesSummaryPermissions,
} from "./salesPermissions";
export { filesPermissions } from "./filesPermissions";
export {
  arubaMailPermissions,
  epsMailPermissions,
} from "./mailPermissions";
export {
  getRoutePermissions,
  isRoutePermissionAllowed,
  resolveRoutePermissions,
} from "./routePermissions";
export {
  learningAdminRoles,
  learningResultsRoles,
  learningViewerRoles,
  getLearningMenuPermissions,
  getLearningResultsPermissions,
  isLearningAdmin,
} from "../tw/learning/admin/learningPermissions";
